import { SET_ASYNC_DATA, SET_LOADING } from './types';
export const setAsyncData = (asyncData, numberOfRows) => ({
  type: SET_ASYNC_DATA,
  asyncData,
  numberOfRows
});
export const setLoading = loading => ({
  type: SET_LOADING,
  loading
});